import Vue from 'vue'
import BasicModel from '@/framework/basic/BasicModel'
Vue.directive('img', {
  bind: function (el, binding, vnode) {
    el.onclick=function(e){
      let dom = e.currentTarget
      let src = dom.currentSrc


      let imageDom = document.getElementById('v-image');

      if(imageDom){
        document.getElementById('v-image-dom').src = src
        document.getElementById('v-image-container').style.display ='block'
      }else{
        var divDom = document.createElement('div');
        divDom.id="v-image"
        divDom.innerHTML =
          `<style media="screen" scoped>
          .m-p-g__controls-close {
            top: 3vh;
            left: 3vw;
            z-index: 5;
          }

          .m-p-g__btn {
              display: -webkit-inline-box;
              display: -webkit-inline-flex;
              display: -ms-inline-flexbox;
              display: inline-flex;
              -webkit-box-align: center;
              -webkit-align-items: center;
              -ms-flex-align: center;
              align-items: center;
              -webkit-box-pack: center;
              -webkit-justify-content: center;
              -ms-flex-pack: center;
              justify-content: center;
              width: 50px;
              height: 50px;
              border-radius: 50%;
              background: rgba(255,255,255,.07);
              -webkit-transition: all .25s ease-out;
              transition: all .25s ease-out;
          }

          .m-p-g__controls-arrow, .m-p-g__controls-close {
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              border: none;
              background: 0 0;
          }

          .m-p-g__controls-arrow, .m-p-g__controls-close {
              position: absolute;
              cursor: pointer;
              -webkit-tap-highlight-color: transparent;
          }
          </style>`

          +`<div id="v-image-container" style="display: block;background: #000;z-index: 1000000; position: fixed;top: 0;left: 0;bottom: 0;right: 0;width: 100%;    margin: 0;padding: 0;">`
          +`<button onclick="document.getElementById('v-image-container').style.display ='none'" class="m-p-g__controls-close"><span data-v-1a826ee8="" class="m-p-g__btn"><svg data-v-1a826ee8="" fill="#FFFFFF" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path data-v-1a826ee8="" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path> <path data-v-1a826ee8="" d="M0 0h24v24H0z" fill="none"></path></svg></span></button>`
          +'<img id="v-image-dom" src="'+src+'" onclick="function(e){e.stopPropagation();}" style="height: 100%;display: block;margin: 0 auto;user-select:none">'
          +'</div>';

        document.getElementsByTagName('body')[0].append(divDom)
      }




    }
  }
})
